export default __webpack_public_path__ + "static/media/043-pedestrian.e067ad07.png";